<template lang="html">
  <div @click.self="closeOverlay" class="overlay" :class="classes" v-if="!destroyed" >
    <div class="inner">
      <div @click="closeOverlay" class="close-overlay">
        <Sprite name="close" />
      </div>

      <slot />
    </div>
  </div>
</template>

<script>
import Sprite from '@/components/Sprite'

export default {
  name: 'overlay',

  data() {
    return {
      created: false,
      destroyed: false
    }
  },

  props: {
    link: {
      type: Object,
      description: 'Where should the page go when the overlay has closed?'
    },

    width: {
      type: String,
      default: 'medium',
      description: 'x-small, small, medium, large or x-large'
    },

    autoHeight: {
      type: Boolean,
      default: false,
      description: 'sets the height of the inner styling to auto'
    },

    withinOverlay: {
      type: Boolean,
      default: false,
      description: `
        This is when an overlay is inside of another overlay.
        If value is set to true, background will be lighter.
      `
    },

    hasStickyHeading: {
      type: Boolean,
      default: false,
      description: 'Removes the top padding if true'
    }
  },

  components: {
    Sprite
  },

  computed: {
    classes() {
      return [
        `is-${this.width}`,
        {'has-sticky-heading': this.hasStickyHeading},
        {'is-created': this.created},
        {'is-destroyed': this.destroyed},
        {'within-overlay': this.withinOverlay},
        {'height-auto': this.autoHeight}
      ]
    }
  },

  methods: {
    closeOverlay() {
      this.created = false

      if (this.link) {
        window.setTimeout(() => {
          this.$router.push(this.link)
        }, 333)
      } else {
        window.setTimeout(() => {
          this.$emit('destroy')
          this.destroyed = true
        }, 333)
      }
    }
  },

  created() {
    this.created = true
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/base/theme'
@import '../stylesheets/helpers/mixins'

.overlay
  position: fixed
  top: 0
  left: 0
  width: 100%
  height: 100%
  display: flex
  align-items: center
  justify-content: center
  opacity: 0
  background: rgba(0, 0, 0, 0.6)
  z-index: 999
  -webkit-transform: translate3d(0, 0, 0) translateZ(0)
  -webkit-backface-visibility: hidden
  -webkit-perspective: 1000

  &.within-overlay
    background: rgba(0, 0, 0, 0.3)
    top: 0
    bottom: 0

    .inner
      max-width: 75%!important

  &.height-auto
    .inner
      height: auto
      max-height: 90vh

  @include media($media-gt-medium)
    &.is-x-small
      .inner
        max-width: 500px

    &.is-small
      .inner
        max-width: 700px

    &.is-medium
      .inner
        max-width: 65%

    &.is-large
      .inner
        max-width: 95%

  &.has-sticky-heading
    .inner
      padding: 0 $gap-large

      .inner
        padding: $gap-large

    .page-header
      top: $gap-small

  .page-header
    border-bottom: 1px solid $color-border!important
    margin-bottom: $gap-large

    h1
      font-size: 12px
      margin-right: $gap-x-small!important

      @include themify($themes)
        color: themed('color-secondary')

  .overlay-heading
    border-bottom: 1px solid $color-border
    padding-bottom: $gap-small
    margin-bottom: $gap-medium
    margin-top: 0
    text-align: left
    font-size: 16px

  .inner
    width: 100%
    opacity: 0
    background: #fff
    transform: scale(0)
    max-width: 90%
    height: $overlay-height
    padding: $gap-large
    overflow: auto
    border-radius: 5px
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.3)
    position: relative

  &.is-created
    animation: fadeIn .5s ease-in-out
    animation-fill-mode: forwards

    .inner
      animation: scaleIn .5s ease-in-out
      animation-fill-mode: forwards

  &.is-destroyed
    animation: fadeOut .5s ease-in-out

    .inner
      animation: scaleOut .5s ease-in-out

  .table
    .inner-scroll
      max-height: none

  .page-header
    padding: $gap-small 0!important

.close-overlay
  position: fixed
  top: $gap-small
  right: 15px
  cursor: pointer
  z-index: 1

  .sprite
    width: 15px
    height: 15px
    fill: rgba(0, 0, 0, 0.2)
</style>
